export const LARGE_SIZE_HEIGHT = 48;
export const MEDIUM_SIZE_HEIGHT = 40;
export const SMALL_SIZE_HEIGHT = 32;
export const ALL_SIZES = {
    m: MEDIUM_SIZE_HEIGHT,
    s: SMALL_SIZE_HEIGHT,
    l: LARGE_SIZE_HEIGHT,
};
